import React, { useEffect,useRef, useState  } from 'react'
import { Link } from 'react-router-dom';
import {ApiService} from '../../containers/Services/apiservice';

let apiServices = new ApiService();
const Footer = () =>{
    // const [email, setEmail] = useState('');
    // const [address, setAddress] = useState('');
    const [facebook, setFacebook] = useState('');
    const [twitter, setTwitter] = useState('');
    const [linkedin, setLinkedin] = useState('');
    const [instagram, setInstagram] = useState('');
    const [footer1, setfooter1] = useState('');
    const [footer2, setfooter2] = useState('');
    const [footer3, setfooter3] = useState('');
    const [footer4, setfooter4] = useState('');
    const [newsemail, setnewsemail] = useState('');
    const [youtube, setYoutube] = useState('');
    const didMountRef = useRef(true);
    useEffect(() => {
        if (didMountRef.current) { 
            apiServices.footerGetRequest().then(res => {
                if(res.data.status=='success'){
                    // setEmail(res.data.data.gs_email);
                    // setAddress(res.data.data.gs_address);
                    setFacebook(res.data.data.gs_facebook_url);
                    setTwitter(res.data.data.gs_twitter_url);
                    setLinkedin(res.data.data.gs_linkedin_url);
                    setInstagram(res.data.data.gs_instagram_url);
                    setYoutube(res.data.data.gs_youtube_url);
                }
              })
        apiServices.getfooterdata().then(res => {
                if(res.data.status=='success'){
                    setfooter1(res.data.data.footer_desc1)
                    setfooter2(res.data.data.footer_desc2)
                    setfooter3(res.data.data.footer_desc3)
                    setfooter4(res.data.data.footer_desc4)
                }
              })  
        }
        didMountRef.current = false;
    });
    const subsribenewsletter = () => {
        const dataString = {
            "email":newsemail
        } 
        apiServices.subscribenewsletter(dataString).then(res => {
            if(res.data.status=='success'){
             alert('Subscribed to Newsletter');   
            }
            else
            {
            alert('You Have Already Subscribed to Our Newsletter');   
            }
          })    
    }
return(
    <div>
<footer>
    <div className="container-fluid">
        <div className="row">
            <div className="col-lg-5">
                <a className="footer-logo" href="#"><img src="/img/logo.png" alt="logo" /></a>
                <span dangerouslySetInnerHTML={{ __html: footer1 }}></span>
                {/* <p>Goalstox Technologies builds platforms &amp; investment products to invest better in Indian equities. A Goalstox is a basket of stocks/ETFs weighted intelligently to reflect an idea</p> */}
                <p><strong>Get market insights and facts right in your inbox</strong></p>
                <div className="newsletter">
                    <input type="email" onChange={(e) => {setnewsemail(e.target.value)}} placeholder="Enter Your Email ID" />
                    <button type="button" onClick={() => {subsribenewsletter();}} className="btn btn-primary newsletter-button">Subscribe</button>
                </div>
            </div>
            <div className="col-lg-2 col-6">
                <div className="footer-title">Quick Links</div>
                <div className="footer-list" dangerouslySetInnerHTML={{ __html: footer2 }}>
                    {/* <ul>
                        <li><Link to="/about-us">About</Link></li>
                        <li><Link to="/product-pricing">Product &amp; Pricing</Link></li>
                        <li><Link to="/contact">Contact</Link></li>
                        <li><Link to="/blog">Blog</Link></li>
                    </ul> */}
                </div>
            </div>
            <div className="col-lg-2 col-6">
                <div className="footer-title">Useful Links</div>
                <div className="footer-list" dangerouslySetInnerHTML={{ __html: footer3 }}>
                    {/* <ul>
                        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                        <li><Link to="/terms-conditions">Terms &amp; Conditions</Link></li>
                        <li><Link to="/refund-policy">Refund Policy</Link></li>
                    </ul> */}
                </div>
            </div>
            <div className="col-lg-3">
                <div className="footer-title" >Contact Info</div>
                <span dangerouslySetInnerHTML={{ __html: footer4 }}></span>
                {/* <p>{address}</p>
                <p>Email: {email}</p> */}
                <div className="footer-title">Find us on</div>
                <div className="social-footer">
                    <ul>
                        {
                            facebook!=null?<li>
                            <a href={facebook} target="new"><i className="fa fa-facebook" aria-hidden="true"></i></a>
                            </li>:null
                        }
                        {
                            twitter!=null?<li>
                            <a href={twitter}><i className="fa fa-twitter" aria-hidden="true"></i></a>
                        </li>:null
                        }
                        {
                            linkedin!=null? <li>
                            <a href={linkedin}><i className="fa fa-linkedin" aria-hidden="true"></i></a>
                        </li>:null
                        }
                        {
                            instagram!=null?  <li>
                            <a href={instagram}><i className="fa fa-instagram" aria-hidden="true"></i></a>
                        </li>:null
                        }
                        {
                            youtube!=null?   <li>
                            <a href={youtube}><i className="fa fa-youtube" aria-hidden="true"></i></a>
                        </li>:null
                        }                      
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>
<div className="copyright">Copyright © 2022 Goalstox</div>
</div>
)
} 
export default Footer